import { useContext, useEffect, useState } from "react";
import { Woo } from "../../Helpers/Woo";
import { Context } from "../Context/GlobalContext";
import { useLocalStorage } from "./useLocalStorage";

export const useProductsData = (id = "default") => {
  const ls = useLocalStorage();
  const [error, setError] = useState(false);
  const { productsLoading, setProductsLoading, products, setProducts, langRefreshKey } = useContext(
    Context
  );

  function handleProducts(productsData, fetchId) {
    let lsProducts = ls.getJSON("products") || [];
    const currentProducts = [];
    const addProducts = [];

    if (fetchId === "default") {
      lsProducts = [];
    } else if (fetchId) {
      lsProducts = lsProducts.filter(
        (p) => !p.categories.some((c) => c.id === fetchId)
      );
    }

    for (const prod of lsProducts) {
      currentProducts[prod.id] = prod;
    }

    const url = window.location.pathname;

    for (const productData of productsData) {
      if (productData.name && typeof productData.name === "object") {
        productData = { ...productData, name: Object.values(productData.name)[0] || "" };
      }
      currentProducts[productData.id] = productData;
      if (fetchId !== "default" || productData.categories.some((c) => url.includes(c.slug))) {
        addProducts.push(productData);
      }
    }

    const productsArray = Object.values(currentProducts);
    ls.setJSON("products", productsArray);

    setProducts(addProducts);
  }

  useEffect(() => {
    setProductsLoading(true);

    const fetchPromise =
      id === "default"
        ? Woo.products.all()
        : Woo.products.findByCategory(id);

    fetchPromise
      .then((products) => {
        handleProducts(products, id);
        setProductsLoading(false);
      })
      .catch((e) => {
        setError(e);
        setProductsLoading(false);
      });
  }, [id, langRefreshKey]);

  return { products, productsLoading, error };
};
